import { OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { Suspense, useRef } from 'react';
import { CAMERA_FOV } from '../../constants';
import { Content } from '../content/content';
import { WaterMark } from '../water-mark/water-mark';

export const Model = () => {
	const canvasRef = useRef<HTMLCanvasElement>(null);

	return (
		<Canvas
			camera={{ position: [0, 0, 4], fov: CAMERA_FOV }}
			gl={{ localClippingEnabled: true }}
			ref={canvasRef}
		>
			<ambientLight />
			<directionalLight />
			<OrbitControls
				enablePan={false}
				minDistance={2}
				maxDistance={5}
				minPolarAngle={0}
				maxPolarAngle={Math.PI / 2}
			/>
			<Suspense fallback={null}>
				<Content />
				<WaterMark />
			</Suspense>
		</Canvas>
	);
};
